import React from "react";
import { Trans } from "react-i18next";

import HeroZmt from "./animations/hero-zmt";
import HeroZmtMobile from "./animations/hero-zmt-mobile";

const HeroZmtSection = () => {
  return (
    <>
      <div className="hero-container  d-none d-lg-block">
        <div className="bg-zmt-gradient">
          <div id="hero-zmt-page" className="mt-auto">
            <div className="container">
              <div className="text-center">
                <div
                  data-sal="slide-up"
                  data-sal-duration="400"
                  data-sal-easing="ease-in-quad"
                >
                  <h1>
                    <Trans
                      i18nKey="zmt.hero.title"
                      components={[<br className="desktop" />]}
                    />
                  </h1>
                </div>
                <div
                  data-sal="slide-up"
                  data-sal-duration="400"
                  data-sal-easing="ease-in-quad"
                >
                  <p>
                    <Trans i18nKey="zmt.hero.description" components={[]} />
                  </p>
                </div>
              </div>
              <HeroZmt />
            </div>
          </div>
          <div className="bg-part-white" />
        </div>
      </div>

      <div className="hero-container d-lg-none overflow-hidden">
        <div className="bg-zmt-gradient">
          <div id="hero-zmt-page" className="mt-auto overflow-hidden">
            <div className="container px-0">
              <div className="text-center">
                <div
                  data-sal="slide-up"
                  data-sal-duration="400"
                  data-sal-easing="ease-in-quad"
                >
                  <h1>
                    <Trans
                      i18nKey="zmt.hero.title"
                      components={[<br className="desktop" />]}
                    />
                  </h1>
                </div>
                <div
                  data-sal="slide-up"
                  data-sal-duration="400"
                  data-sal-easing="ease-in-quad"
                >
                  <p>
                    <Trans i18nKey="zmt.hero.description" components={[]} />
                  </p>
                </div>
              </div>
              <HeroZmtMobile />
            </div>
          </div>
          <div className="bg-part-white" />
        </div>
      </div>
    </>
  );
};

export default HeroZmtSection;
